import React from 'react';
import styled, { css } from 'styled-components';
import { MediaQueries } from './MainLayout';

export interface SystemBlockProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  icon?: string | null;
  size?: 'tight' | 'small' | 'medium' | 'large';
}

const SystemBlockContainer = styled.section<SystemBlockProps>`
  background: var(--main-bkg-color);

  > div {
    margin: 0 auto;
    max-width: 1440px;
  }

  ${MediaQueries.desktopOnly} {
    --systemBlockGap: 36px;
    & > div {
      padding: 120px 96px;
    }
  }

  ${MediaQueries.tabletOnly} {
    --systemBlockGap: 24px;
    & > div {
      padding: 96px 48px;
    }
  }

  ${MediaQueries.phoneOnly} {
    --systemBlockGap: 12px;
    & > div {
      padding: 72px 24px;
    }
  }

  ${({ size }) =>
    size === 'tight' &&
    css`
      & > div {
        padding-top: 0;
        padding-bottom: var(--spacing-10);
      }
    `}
`;

const SystemBlock = React.forwardRef<HTMLElement, SystemBlockProps>(
  ({ children = '', size = 'medium', ...props }, ref) => {
    return (
      <SystemBlockContainer ref={ref} size={size} {...props}>
        <div>{children}</div>
      </SystemBlockContainer>
    );
  },
);

export default SystemBlock;
